import { serializeBaseUrlParam } from './parameters.model';
import { SelectParameters } from './select-parameters.model';
import { serializeArrayToUrlParams } from './serialization-functions.model';

export interface RdsProfileParameters extends SelectParameters {
  weights?: Array<string>;
}

export function serializeProfileParams(params: RdsProfileParameters): string {
  if (!params) {
    return '';
  }
  let path = '';
  for (const prop in params) {
    if (params.hasOwnProperty(prop)) {
      const value = params[prop];
      switch (prop) {
        case 'cols':
        case 'weights':
          path += serializeArrayToUrlParams(prop, value);
          break;
        default:
          path += serializeBaseUrlParam(prop, value);
      }
    }
  }

  // Remove trailing ampersand
  if (path[path.length - 1] === '&') {
    path = path.substr(0, path.length - 1);
  }

  return path;
}
